import { Injectable } from '@angular/core';
import { ListsApi } from './lists.api';
import { map, Observable } from 'rxjs';
import { iRankingBet } from '../ranking/ranking.interface';
import { iUser } from './user.interface';

@Injectable({
	providedIn: 'root'
})
export class ListsService {

	constructor(
		private api: ListsApi,
	) { }

	private getUserFromData(data:any): iUser {
		return {
			position: data["position"],
			points: +data["points"],
			year: +data["year"],
			name: data["name"],
			location: `${data["city"]} (${data["state"]})`,
			sent: data["created_at"],
			list: data["list"].map((d: any) => this.getBetFromUserRow(d)),
		};
	}
	private getBetFromUserRow(data: any): iRankingBet {
		return {
			id: data["id"],
			name: data["name"],
			points: data["points"],
			death_id: data["death_id"],
		};
	}

	public register(data: any): Observable<any> {
		return this.api.register(data);
	}

	public view(hash:string): Observable<any> {
		return this.api.view(hash)
			.pipe(map(rs => this.getUserFromData(rs)));
	}

	public recover(email: string, year?: number): Observable<any> {
		return this.api.recover(email, year);
	}

	public giveMeNames(qt:number=15): string[] {
		const dbNames = [
			"Xuxa",
			"Moacyr Franco",
			"Michael J Fox",
			"Justin Bieber",
			"Maguila",
			"Paul McCartney",
			"Donald Trump",
			"Edir Macedo",
			"Boris Casoy",
			"Michel Temer",
			"Charlie Sheen",
			"Chico Buarque",
			"William Bonner",
			"Padre Marcelo Rossi",
			"Ney Latorraca",
			"Lady Gaga",
			"Edgar Vivar",
			"Dilma",
			"Carlos Villagran",
			"Rafael Ilha",
			"Macaulay Culkin",
			"Sérgio Moro",
			"Selena Gomez",
			"Michael Douglas",
			"Netinho",
			"Lindsay Lohan",
			"Edson Celulari",
			"Tarcísio Meira",
			"Príncipe Philip",
			"Orlando Drummond",
			"Kirk Douglas",
			"Gugu Liberato",
			"Tônia Carrero",
			"Stan Lee",
		].sort(() => Math.random() - 0.5);
		return dbNames.slice(0, qt);
	}
}
